import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menu: {
    path: window.location.pathname,
    isModalOpen: false,
    promiseStatus: false,
  },
  gantt: {
    zoom: 3,
    jobsACC: true,
    jobsMenuRetract: false,
  },

  workflow: {
    markers: true,
    outscoped: true,
  },
};

const menuBarReducers = {
  pathTo: (state, action) => {
    state.menu.path = action.payload;
  },
  openModal: (state) => {
    state.menu.isModalOpen = true;
  },
  closeModal: (state) => {
    state.menu.isModalOpen = false;
  },
};

const ganttReducers = {
  addZoom: (state) => {
    if (state.gantt.zoom === 3) {
      return;
    }
    state.gantt.zoom = state.gantt.zoom + 1;
  },
  subZoom: (state) => {
    if (state.gantt.zoom === 1) {
      return;
    }
    state.gantt.zoom = state.gantt.zoom - 1;
  },

  changeJobstoAll: (state) => {
    state.gantt.jobsACC = false;
  },
  changeJobstoACC: (state) => {
    state.gantt.jobsACC = true;
  },
  openJobsMenu: (state) => {
    state.gantt.jobsMenuRetract = true;
  },
  closeJobsMenu: (state) => {
    state.gantt.jobsMenuRetract = false;
  },
};

const workflowReducers = {
  turnOnMarkers: (state) => {
    state.workflow.markers = true;
  },
  turnOffMarkers: (state) => {
    state.workflow.markers = false;
  },

  turnOnOutscoped: (state) => {
    state.workflow.outscoped = true;
  },
  turnOffOutscoped: (state) => {
    state.workflow.outscoped = false;
  },
};

const zaivuPersist = createSlice({
  name: "zaivuPersist",
  initialState,
  reducers: {
    ...menuBarReducers,
    ...ganttReducers,
    ...workflowReducers,
  },
});

export const {
  pathTo,
  openModal,
  closeModal,
  addZoom,
  subZoom,
  changeJobstoAll,
  changeJobstoACC,
  openJobsMenu,
  closeJobsMenu,
} = zaivuPersist.actions;
export default zaivuPersist.reducer;
